@for (formComponent of formComponents; track $index) {
    <div class="mb-3">
        <ng-container *ngComponentOutlet="
            formComponent.componentType;
            injector: formComponent.customInjector;
            inputs: formComponent.componentInputs">
        </ng-container>
    </div>
    }